var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThreeDotHorizontal = function SvgThreeDotHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M20.75 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M4.25 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M20.75 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M4.25 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })));
};
export default SvgThreeDotHorizontal;